/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_External_Booking_Edit_Contact_DetailsInputs */

const en_admin_external_booking_edit_contact_details = /** @type {(inputs: Admin_External_Booking_Edit_Contact_DetailsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Contact Details`)
};

const de_admin_external_booking_edit_contact_details = /** @type {(inputs: Admin_External_Booking_Edit_Contact_DetailsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kontaktdaten`)
};

const es_admin_external_booking_edit_contact_details = /** @type {(inputs: Admin_External_Booking_Edit_Contact_DetailsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Datos de contacto`)
};

const fr_admin_external_booking_edit_contact_details = /** @type {(inputs: Admin_External_Booking_Edit_Contact_DetailsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Coordonnées`)
};

/** @type {(inputs: Admin_External_Booking_Edit_Contact_DetailsInputs) => LocalizedString} */
const it_admin_external_booking_edit_contact_details = en_admin_external_booking_edit_contact_details;

/** @type {(inputs: Admin_External_Booking_Edit_Contact_DetailsInputs) => LocalizedString} */
const pt_br2_admin_external_booking_edit_contact_details = en_admin_external_booking_edit_contact_details;

/** @type {(inputs: Admin_External_Booking_Edit_Contact_DetailsInputs) => LocalizedString} */
const pl_admin_external_booking_edit_contact_details = en_admin_external_booking_edit_contact_details;

/** @type {(inputs: Admin_External_Booking_Edit_Contact_DetailsInputs) => LocalizedString} */
const hu_admin_external_booking_edit_contact_details = en_admin_external_booking_edit_contact_details;

/** @type {(inputs: Admin_External_Booking_Edit_Contact_DetailsInputs) => LocalizedString} */
const ro_admin_external_booking_edit_contact_details = en_admin_external_booking_edit_contact_details;

/**
* | output |
* | --- |
* | "Contact Details" |
*
* @param {Admin_External_Booking_Edit_Contact_DetailsInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_external_booking_edit_contact_details = /** @type {((inputs?: Admin_External_Booking_Edit_Contact_DetailsInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_External_Booking_Edit_Contact_DetailsInputs, { locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_external_booking_edit_contact_details(inputs)
	if (locale === "de") return de_admin_external_booking_edit_contact_details(inputs)
	if (locale === "es") return es_admin_external_booking_edit_contact_details(inputs)
	if (locale === "fr") return fr_admin_external_booking_edit_contact_details(inputs)
	if (locale === "it") return it_admin_external_booking_edit_contact_details(inputs)
	if (locale === "pt-BR") return pt_br2_admin_external_booking_edit_contact_details(inputs)
	if (locale === "pl") return pl_admin_external_booking_edit_contact_details(inputs)
	if (locale === "hu") return hu_admin_external_booking_edit_contact_details(inputs)
	return ro_admin_external_booking_edit_contact_details(inputs)
});
export { admin_external_booking_edit_contact_details as "admin.external_booking_edit.contact_details" }